import { Injectable } from '@angular/core';
import { RefreshTokenService } from 'abp-ng2-module';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ZeroRefreshTokenService implements RefreshTokenService {
    constructor(
        private _tokenAuthService: TokenAuthServiceProxy
    ) {}

    tryAuthWithRefreshToken(): Observable<boolean> {
        return this.tryAuthWithHttpOnlyRefreshToken();
    }

    private tryAuthWithHttpOnlyRefreshToken(): Observable<boolean> {
        let refreshTokenObservable = new Subject<boolean>();

        // works because we pass the refresh token in the http-only cookie
        // along with the request
        this._tokenAuthService.isRefreshTokenAvailable().subscribe({
            next: (result) => {

                if (!result) {
                    refreshTokenObservable.next(false);
                    refreshTokenObservable.complete();
                    return;
                }

                this._tokenAuthService.refreshToken(undefined).subscribe({
                    next: (tokenResult) => {
                        if (!tokenResult || !tokenResult.accessToken) {
                            refreshTokenObservable.next(false);
                        } else {
                            // new access token is returned in http-only cookie
                            refreshTokenObservable.next(true);
                        }
                        refreshTokenObservable.complete();
                    },
                    error: (errResult) => {
                        refreshTokenObservable.next(false);
                        refreshTokenObservable.complete();
                    }
                });
            },
            error: () => {
                refreshTokenObservable.next(false);
                refreshTokenObservable.complete();
            }
        });

        return refreshTokenObservable;
    }
}
